import { useEffect, useState } from "react";
import { RootState } from "../redux/store";
import { Button, Card, Form, Table } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { API } from "../config/api";
import { POST } from "../utils/apicalls";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
declare module "jspdf" {
  interface jsPDF {
    autoTable: (options: any) => void;
  }
}
function PaymentDetails() {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});

  const user: any = useSelector((state: RootState) => state?.user); // Access user state

  const columns = [
    {
      dataIndex: "type",
      title: "Type",
      render: (type: any) => {
        let color = "";
        switch (type?.toLowerCase()) {
          case "approved":
            color = "green";
            break;
          case "rejected":
            color = "red";
            break;
          default:
            color = "black"; // Default color for other statuses
        }
        return <span style={{ color }}>{type}</span>;
      },
    },

    {
      dataIndex: "date",
      title: "Date",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },

    {
      dataIndex: "ClientId",
      title: "Client Name",
      render: (_: any, value: any) => {
        const employeeName = value?.client?.companyName || "N/A";
        return <span>{employeeName}</span>;
      },
    },

    {
      dataIndex: "IN_Amount",
      title: "IN_Amount",
    },
    {
      dataIndex: "OUT_Amount",
      title: "OUT_Amount",
    },
    {
      dataIndex: "TotalAmount",
      title: "TotalAmount",
    },
    {
      dataIndex: "category",
      title: "Category",
    },
    {
      dataIndex: "method",
      title: "Method",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={() => handleRowClick(record)}
        />
      ),
    },
  ];

  console.log("object", user.id)

  // Fetch salary data
  const fetchSalary = async (page: any, values: any) => {
    try {
      setIsLoading(true);
      let obj = {

        ClientId: user?.id,
        category: "payments",
      };
      const url = API.SEARCH_SALARY_DETAILS;
      const response: any = await POST(url, obj);

      // Filter out "payments" and "salary" categories
      const filteredData = response?.data.filter(
        (item: any) => item.category === "payments"
      );

      setData(filteredData);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle row click for PDF download
  const handleRowClick = (record: any) => {
    const doc = new jsPDF();

    // Add title
    doc.setFontSize(16);
    doc.text("Payment Details", 10, 10);

    // Add table data
    const tableData = [
      ["Type", record.type],
      ["Date", moment(record.date).format("DD/MM/YYYY") || "-"],
      ["Client Name", record?.client?.companyName || "N/A"],
      ["IN_Amount", record.IN_Amount || "-"],
      ["OUT_Amount", record.OUT_Amount || "-"],
      ["TotalAmount", record.TotalAmount || "-"],
      ["Category", record.category || "-"],
      ["Method", record.method || "-"],
    ];

    doc.autoTable({
      startY: 20,
      head: [["Field", "Value"]],
      body: tableData,
    });

    // Save the PDF
    doc.save(`PaymentDetails_${record.id}.pdf`);
  };

  useEffect(() => {
    fetchSalary(page, pageSize);
  }, [page, pageSize]);

  return (
    <div>
      <h1> Client Payment Details</h1>
      <Card>
        <Table
          columns={columns}
          dataSource={data}
          loading={isLoading}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
            },
          }}
        />
      </Card>
    </div>
  );
}

export default PaymentDetails;
